import {reactFetch} from '@github-ui/verified-fetch'
import {useCallback} from 'react'

/** POST target for dismissing the repository's content warning banner. */
function dismissContentWarningBannerPath({owner, repo}: {owner: string; repo: string}) {
  return `/${encodeURIComponent(owner)}/${encodeURIComponent(repo)}/dismiss_content_warning_banner`
}

export function useDismissContentWarning(owner: string, repo: string) {
  const dismissContentWarning = useCallback(async () => {
    const form = new FormData()
    // Mirror the server's `return_to_path` helper (request.original_url / referrer); the full current URL
    form.append('return_to', `${window.location.origin}${window.location.pathname}${window.location.search}`)
    const response = await reactFetch(dismissContentWarningBannerPath({owner, repo}), {
      method: 'POST',
      body: form,
    })

    if (!response.ok) {
      throw new Error(`Failed to dismiss content warning banner: ${response.status} ${response.statusText}`)
    }

    // The banner was dismissed server-side, so it should now be removed.
    return true
  }, [owner, repo])

  return {dismissContentWarning}
}
